module.exports = __webpack_public_path__ + "img/1440.f3be70b2.jpg";